import { GetServerSidePropsContext } from 'next';
import { ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client';

import VIDEO_QUERY from 'graphql/content/queries/video.graphql';

import type {
  GetVideoBySlugQuery,
  GetVideoBySlugQueryVariables,
} from 'graphql/types';

import { NotFoundStatusCode } from 'utils/constants';

export const useVideo = (slug: string) =>
  useQuery<GetVideoBySlugQuery>(VIDEO_QUERY, {
    variables: {
      slug,
    } as GetVideoBySlugQueryVariables,
  });

export const getVideoSsr = async (
  { res }: GetServerSidePropsContext,
  client: ApolloClient<NormalizedCacheObject>,
  slug: string
) => {
  try {
    const {
      data: { videoBySlug },
    } = await client.query<GetVideoBySlugQuery>({
      query: VIDEO_QUERY,
      variables: { slug },
    });

    if (!videoBySlug) {
      res.statusCode = NotFoundStatusCode;
    }
  } catch (err) {
    return {
      notFound: true,
    };
  }
};
